import { DateTime } from 'luxon';
import { Instance, SnapshotOut, applySnapshot, flow, getParent, types } from 'mobx-state-tree';

import { removeMeet, updateMeet } from '@common/api/meets';
import Student from '@common/models/Users/Students/Student';

import { IReworkingMeetsModel } from './ReworkingMeets';

const ReworkingMeet = types
	.model('ReworkingMeet', {
		id: types.identifierNumber,
		location: types.frozen(),
		service_id: types.number,
		end_dt: types.string,
		start_dt: types.string,
		status: types.maybeNull(types.number),
		teacher: types.maybeNull(types.frozen()),
		student: Student,
		meetSlot: types.frozen(),
		programGroup: types.frozen(),
		gradebook: types.frozen(),
		type: 'working_off',
		zoom_access_code: types.maybeNull(types.string),
		zoom_id: types.maybeNull(types.string),
		zoom_link: types.maybeNull(types.string),
		miro_link: types.maybeNull(types.string),
		phone: types.maybeNull(types.string),
		comment_teacher: types.maybeNull(types.string),
	})
	.views((self) => ({
		get startDateTime() {
			return DateTime.fromSQL(self.start_dt);
		},
		get endDateTime() {
			return DateTime.fromSQL(self.end_dt);
		},
	}))
	.views((self) => ({
		get weekday(): number {
			return self.startDateTime.weekday;
		},
		get hourNumber(): number {
			return self.startDateTime.hour;
		},
		get hourSlotNumber(): 0 | 1 {
			return Math.floor(self.startDateTime.minute / 30) as 0 | 1; // @TODO: Const
		},
		get timesString() {
			return `${self.startDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)} - ${self.endDateTime.toLocaleString(DateTime.TIME_24_SIMPLE)}`;
		},
		get lessonSlotNumber() {
			return (self.startDateTime.hour - 9 + self.startDateTime.minute / 60) * 2 - 1;
		},
	}))
	.actions((self) => ({
		save: flow(function* (data: any) {
			const result = yield updateMeet(self.id, data);
			applySnapshot(self, result);
		}),
		remove: flow(function* () {
			yield removeMeet(self.id);
			const parent = getParent(self, 2) as IReworkingMeetsModel;
			parent.removeMeet(self);
		}),
	}));

export default ReworkingMeet;

export interface IReworkingMeetModel extends Instance<typeof ReworkingMeet> {}
export type IReworkingMeetSnapshotOut = SnapshotOut<typeof ReworkingMeet>;
